var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ButtonGroup',{class:_vm.groupClass},_vm._l((_vm.data),function(item,index){return _c('Button',{key:index,class:{ 'ivu-btn-primary': _vm.withValue(item.value) },on:{"click":function($event){return _vm.tagStepBtn(item, _vm.data)}}},[_vm._v(_vm._s(item.label)+" ")])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }